export default {
  practiceTrain_num_submit:'{submitCount}人提交',
  practiceTrain_ckeck_summary:"点击每周查看对应的周总结",
  practiceTrain_training_category:'培训类别:',
  practiceTrain_submit_count:'{submitCount}人已提交',
  practiceTrain_daily_report:'点击日期查看对应的日报',
  practiceTrain_student:'学员',
  practiceTrain_director:'指导人',
  practiceTrain_instructor:'指导员',
  practiceTrain_rotation:'轮岗',
  practiceTrain_mentor_program:'指导人计划',
  practiceTrain_action_learn:'行动学习',
  practiceTrain_personal_develop_plan:'个人发展计划',
  practiceTrain_manager:"主管",
  practiceTrain_director_plan_task: '部门长',
  practiceTrain_train_title01:'试用期工作记录表',
  practiceTrain_train_title02:'日报（新人每日总结）',
  practiceTrain_train_title03:'周报（新人每周总结）',
  practiceTrain_train_title04:'月报（面谈跟踪记录表）',
  practiceTrain_train_title05:'指导人评价表',
  practiceTrain_train_fillCard01:'查看指导人安排的阶段工作规划',
  practiceTrain_train_fillCard02:'培训过程中需填写日报',
  practiceTrain_train_fillCard03:'培训过程中需要填写周报',
  practiceTrain_train_fillCard04:'培训过程中需要填月报',
  practiceTrain_train_fillCard05:'请填写对指导人的评价',
  practiceTrain_mentor_title01:'指导人任务清单',
  practiceTrain_mentor_title02:'试用期工作记录表',
  practiceTrain_mentor_title03:'日报（新人每日总结）',
  practiceTrain_mentor_title04:'周报（新人每周总结）',
  practiceTrain_mentor_title05:'月报（面谈跟踪记录表）',
  practiceTrain_mentor_title06:'转正考核表',
  practiceTrain_mentor_fillCard01:'需指导人分阶段填报任务完成情况',
  practiceTrain_mentor_fillCard02:'需指导人对学员填写工作计划',
  practiceTrain_mentor_fillCard03:'查看学员提交的日报',
  practiceTrain_mentor_fillCard04:'查看学员提交的周报',
  practiceTrain_mentor_fillCard05:'需指导人填写学员报评价',
  practiceTrain_mentor_fillCard06:'需指导员填写学员转正意见',
  practiceTrain_manager_title01:'月报（面谈跟踪记录表）',
  practiceTrain_manager_fillCard01:'审阅学员提交的月报与指导人意见',
  practiceTrain_director_title01:'月报（面谈跟踪记录表）',
  practiceTrain_director_title02:'转正考核表',
  practiceTrain_director_fillCard01:'审阅学员提交的月报与指导人意见',
  practiceTrain_director_fillCard02:'需部门长填写学员转正意见',
  practiceTrain_train02_title01:'学员发展计划表-',
  practiceTrain_train02_title02:'学员发展计划表-',
  practiceTrain_train02_title03:'学员发展计划表-',
  practiceTrain_train02_fillCard01:'培训期间每个阶段填报发展计划与反思',
  practiceTrain_train02_fillCard02:'培训期间每个阶段填报发展计划与反思',
  practiceTrain_train02_fillCard03:'培训期间每个阶段填报发展计划与反思',
  mentor02_title01:'学员发展计划表-',
  mentor02_title02:'学员发展计划表-',
  mentor02_fillCard01:'需指导人对学员计划填写评价',
  mentor02_fillCard02:'需指导人对学员计划填写评价',
  manager02_title01:'主管评价表（前测）',
  manager02_title02:'主管评价表（后测）',
  manager02_fillCard01:'需主管在培训前对学员填写评价',
  manager02_fillCard03:'需主管在培训后对学员填写评价',
  practiceTrain_leave_page01:'评价表（前测）',
  practiceTrain_leave_page02:'评价表（后测）',
  practiceTrain_leave_page03:'阶段规划与反思回顾',
  practiceTrain_leave_page04:'执行整体反思',
  practiceTrain_leave_page05:'规划',
  practiceTrain_manager_plan_task:"学员发展计划表-",
  practiceTrain_manager_name:'指导人姓名：',
  practiceTrain_current_evaluable:'当前可评价',
  practiceTrain_currently_review:'当前可审阅',
  practiceTrain_people:"{notAuditCount}人",
  practiceTrain_instructor_comment:'需指导人对学员填写评价',
  practiceTrain_training_feedback:'培训项目训后反馈',
  practiceTrain_month_num:"{monthlyNumber}月",
  practiceTrain_week_num:'第{weeklyNumber}周',
  practiceTrain_week_End:"第{weeklyNumber}周({time})",
  practiceTrain_train_time:"培训时间: "

}
